@use '@material/theme' with (
  $primary: #000
);
@use '@material/typography' with (
  $font-family: unquote('Chivo, Roboto, sans-serif'),
  $styles-button: (
    text-transform: uppercase,
    font-size: 0.9375rem,
    font-weight: bold,
    line-height: 1.75,
    letter-spacing: 0.4px,
  )
);

@use '@material/button/styles';

@import url('https://fonts.googleapis.com/css2?family=Chivo:wght@400;700&display=swap');

:host {
  display: block;
  font-family: 'Chivo', sans-serif;
  font-weight: 400;
}

.mdc-button {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
  border-radius: 28px;
  min-width: 212px;
  min-height: 36px;
}
